<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <!-- 搜索过滤栏 -->
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="90px">
            <el-row>
              <el-col :span="18">
                <el-form-item label="账号：" prop="account">
                  <el-input v-model="searchForm.account" placeholder="请输入账号" style="width: 160px" />
                </el-form-item>
                <el-form-item label="真实名称：" prop="username">
                  <el-input v-model="searchForm.username" placeholder="请输入姓名" style="width: 160px" />
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                  <el-select v-model="searchForm.status" placeholder="全部状态" clearable style="width: 160px">
                    <el-option label="正常" :value="0"></el-option>
                    <el-option label="锁定" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6" style="text-align: right; padding-right: 10px;">
                <el-button type="primary" icon="el-icon-search" size="small" plain @click="handleSearch">查询</el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain @click="handleReset" style="margin-left: 8px">重置</el-button>
                <el-button type="success" icon="el-icon-plus" size="small" plain @click="handleCreate">新增</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <!-- 主表格 -->
      <el-row class="main-table">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="60" align="center" />

          <el-table-column prop="id" label="ID" width="200" show-overflow-tooltip />
          <el-table-column prop="account" label="账号" width="140" />
          <el-table-column prop="username" label="真实名称" width="120" />
          <el-table-column label="性别" width="80">
            <template v-slot="scope">
              {{ formatGender(scope.row.gender) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="domain" label="租户" width="120" show-overflow-tooltip />
          <el-table-column label="用户类型" width="120">
            <template v-slot="scope">
              <el-tag :type="getTypeTag(scope.row.type)">{{ formatUserType(scope.row.type) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="dept" label="所属部门ID" width="120" /> -->
          <el-table-column prop="email" label="邮箱" width="180" />
          <el-table-column prop="phone" label="电话" width="130" />
          <el-table-column label="状态" width="100">
            <template v-slot="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
                {{ scope.row.status === 0 ? '正常' : '锁定' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ip" label="最近登录IP" width="130" />
          <el-table-column label="上次登录时间" width="170">
            <template v-slot="scope">
              {{ formatDateTime(scope.row.last) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="170">
            <template v-slot="scope">
              {{ formatDateTime(scope.row.created_at) }}
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column fixed="right" label="操作" width="380" align="center">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="editUser(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="bindOrder(scope.row)">关联订单</el-button>
              <el-button type="text" size="mini" @click="bindProvider(scope.row)">关联提供商</el-button>
              <el-button type="text" size="mini" @click="delUser(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </el-row>
    </el-row>

    <!-- 新增/编辑组件 -->
    <create-user ref="createUser" @success="getTableData" />
    <edit-user ref="editUser" @success="getTableData" />

    <!-- 关联订单订单对话框 -->
    <el-dialog
      title="关联订单"
      :visible.sync="bindOrderDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="handleBindOrderDialogClose"
    >
      <el-form label-width="100px">
        <el-form-item label="用户ID：">
          <el-input v-model="bindOrderForm.user_id" disabled />
        </el-form-item>
        <el-form-item label="用户账号：">
          <el-input v-model="bindOrderForm.user_account" disabled />
        </el-form-item>
        <el-form-item label="选择订单：">
          <el-transfer
            v-model="bindOrderForm.order_ids"
            :data="orderList"
            :titles="['可选订单', '已选订单']"
            filterable
            :filter-method="filterOrder"
            filter-placeholder="请输入订单名称或客户名称"
            :props="{
              key: 'id',
              label: 'label'
            }"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindOrderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBindOrder" :loading="bindOrderLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 关联提供商对话框 -->
    <el-dialog
      title="关联提供商"
      :visible.sync="bindProviderDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="handleBindProviderDialogClose"
    >
      <el-form label-width="100px">
        <el-form-item label="用户ID：">
          <el-input v-model="bindProviderForm.user_id" disabled />
        </el-form-item>
        <el-form-item label="用户账号：">
          <el-input v-model="bindProviderForm.user_account" disabled />
        </el-form-item>
        <el-form-item label="选择提供商：">
          <el-transfer
            v-model="bindProviderForm.provider_ids"
            :data="providerList"
            :titles="['可选提供商', '已选提供商']"
            filterable
            :filter-method="filterProvider"
            filter-placeholder="请输入提供商名称"
            :props="{
              key: 'id',
              label: 'label'
            }"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindProviderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBindProvider" :loading="bindProviderLoading">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import CreateUser from '../user/CreateUser.vue';
import EditUser from '../user/EditUser.vue';
import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'; // 假设 util.js 是项目自定义工具库
import { MessageBox } from 'element-ui';

export default {
  name: 'UserList',
  components: {
    topLine,
    CreateUser,
    EditUser
  },
  data() {
    return {
      pageTitle: '用户列表',
      loading: false,
      searchForm: {
        account: '',
        username: '',
        status: '',
        type: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: [],
      tableDataApi: '/api-30216/api/user',
      bindOrderDialogVisible: false,
      bindOrderLoading: false,
      bindOrderForm: {
        user_id: '',
        user_account: '',
        order_ids: []
      },
      orderList: [],
      bindProviderDialogVisible: false,
      bindProviderLoading: false,
      bindProviderForm: {
        user_id: '',
        user_account: '',
        provider_ids: []
      },
      providerList: []
    };
  },
  mounted() {
    this.loadParams();
    this.getTableData();
  },
  methods: {
    loadParams() {
      const { page, pageSize } = this.$route.query;
      if (page) this.pagination.page = parseInt(page, 10);
      if (pageSize) this.pagination.pageSize = parseInt(pageSize, 10);
    },

    getTableData() {
      this.loading = true;
      const params = { ...this.searchForm, ...this.pagination };

      this.$axios.get(this.tableDataApi, { params })
        .then(res => {
          this.tableData = res.data || [];
          this.pagination.total = res.total || 0;
          this.loading = false;
        })
        .catch(err => {
          console.error('获取用户列表失败：', err);
          this.$message.error('数据加载失败');
          this.loading = false;
        });
    },

    formatGender(val) {
      const map = { 0: '未知', 1: '男', 2: '女' };
      return map[val] || '未知';
    },

    formatUserType(val) {
      const map = { 0: '平台管理员', 1: '租户管理员', 2: '普通用户' };
      return map[val] || '未知';
    },
    getTypeTag(val) {
      return ['warning', 'success', 'info'][val] || 'info';
    },

    // ✅ 修复关键错误：替换 formatDate 为实际存在的方法或使用原生 Date API
    formatDateTime(datetime) {
      if (!datetime) return '';
      
      // 方案一：如果 util.js 中有 format 或其他日期方法，请替换正确函数名
      // return util.format(datetime, 'YYYY-MM-DD HH:mm:ss'); 
      
      // 方案二（推荐）：使用 JavaScript 原生 Date 对象格式化
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return ''; // 防止无效日期
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleSearch() {
      this.pagination.page = 1;
      this.$router.push({
        query: {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
      }).catch(err => {
        // ✅ 已处理 NavigationDuplicated 错误
        if (err.name !== 'NavigationDuplicated') {
          console.error('Unexpected routing error:', err);
        }
      });
      this.getTableData();
    },

    handleReset() {
      this.searchForm = {
        account: '',
        username: '',
        email: '',
        phone: '',
        status: '',
        type: '',
        page: 1,
        pageSize: 10
      };
      this.pagination.page = 1;
      this.handleSearch();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.handleSearch();
    },

    handleCreate() {
      if (this.$refs.createUser && typeof this.$refs.createUser.openDialog === 'function') {
        this.$refs.createUser.openDialog();
      }
    },

    editUser(row) {
      if (this.$refs.editUser && typeof this.$refs.editUser.openDialog === 'function') {
        this.$refs.editUser.openDialog(row);
      }
    },

    delUser(row) {
       MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$axios.delete(`/api-30216/api/user/${row.id}`).then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '删除成功');
          } else {
            this.$message.error(response.message || '删除失败');
          }
          this.getTableData();
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败，请检查网络或服务状态');
        });
        
      }).catch(() => {
        // 用户点击"取消"或关闭弹窗时触发
        this.$message.info('已取消删除');
      });
    },

    bindOrder(row) {
      console.log('开始绑定订单，用户数据:', row);
      
      this.bindOrderForm.user_id = row.id;
      this.bindOrderForm.user_account = row.account;
      this.bindOrderForm.order_ids = [];
      this.bindOrderDialogVisible = true;
      
      console.log('绑定订单表单数据:', this.bindOrderForm);
      
      // 先获取用户已绑定的订单ID，然后再获取订单列表
      this.fetchBoundOrders(row.id).then(() => {
        console.log('已绑定订单获取完成，开始获取订单列表');
        // 已绑定订单获取完成后，再获取订单列表
        this.fetchOrderList();
      }).catch(err => {
        console.error('获取已绑定订单过程中出错:', err);
        // 即使出错也继续获取订单列表
        this.fetchOrderList();
      });
    },
    
    // 获取用户已绑定的订单ID
    fetchBoundOrders(userId) {
      return new Promise((resolve, reject) => {
        console.log('开始获取已绑定订单，用户ID:', userId);
        console.log('请求地址:', '/api-30216/api/user-orders/bound');
        
        this.$axios.get('/api-30216/api/user-orders/bound', {
          params: {
            user_id: userId
          }
        })
        .then(res => {
          console.log('获取已绑定订单响应:', res);
          console.log('响应数据:', res.data);
          console.log('响应数据类型:', typeof res.data);
          console.log('响应数据是否为数组:', Array.isArray(res.data));
          
          // 直接使用响应数据，不检查code
          const boundOrderIds = res.data || [];
          console.log('已绑定订单ID:', boundOrderIds);
          console.log('已绑定订单数量:', boundOrderIds.length);
          
          // 设置已绑定的订单ID到表单
          this.bindOrderForm.order_ids = boundOrderIds;
          
          resolve();
        })
        .catch(err => {
          console.error('获取已绑定订单失败:', err);
          console.error('错误响应:', err.response);
          console.error('错误消息:', err.message);
          
          let errorMsg = '获取已绑定订单失败';
          if (err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message;
          } else if (err.message) {
            errorMsg = err.message;
          }
          
          this.$message.error(errorMsg);
          resolve(); // 即使失败也继续执行
        });
      });
    },

    fetchOrderList() {
      this.$axios.get('/api-30216/api/orders', {
        params: {
          page: 1,
          pageSize: 9999
        }
      }).then(res => {
        if (res.code === 200) {
          // 保存所有订单信息，用于el-transfer组件显示
          this.orderList = (res.data || []).map(order => ({
            id: order.id,
            label: `${order.order_no} - ${order.customer_name || '无客户名称'}`
          }));
          
          console.log('所有订单列表:', this.orderList);
          console.log('已绑定订单ID:', this.bindOrderForm.order_ids);
        } else {
          this.$message.error(res.message || '获取订单列表失败');
          this.orderList = [];
        }
      }).catch(err => {
        console.error('获取订单列表失败:', err);
        this.$message.error('获取订单列表失败');
        this.orderList = [];
      });
    },

    filterOrder(query, item) {
      return item.label.toLowerCase().includes(query.toLowerCase());
    },

    submitBindOrder() {
      if (this.bindOrderForm.order_ids.length === 0) {
        this.$message.warning('请至少选择一个订单');
        return;
      }

      const submitData = {
        user_id: this.bindOrderForm.user_id,
        order_ids: this.bindOrderForm.order_ids
      };

      console.log('提交的JSON数据:', JSON.stringify(submitData, null, 2));

      this.bindOrderLoading = true;
      
      // 按照 EditRole 的提交方式，使用 transformRequest 确保数据被正确序列化为 JSON
      this.$axios
        .post('/api-30216/api/user-orders/bind', submitData, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [postData => JSON.stringify(postData)]
        })
        .then(res => {
          console.log('接口响应:', res);
          const responseData = res.data || res;
          if (responseData.code === 200) {
            this.$message.success(responseData.message || '关联订单成功');
            this.bindOrderDialogVisible = false;
          } else {
            this.$message.error(responseData.message || '关联订单失败');
          }
        })
        .catch(err => {
          let msg = '关联订单失败';
          if (err.response && err.response.data && err.response.data.message) {
            msg = err.response.data.message;
          } else if (err.message) {
            msg = err.message;
          }
          this.$message.error(msg);
        })
        .finally(() => {
          this.bindOrderLoading = false;
        });
    },

    handleBindOrderDialogClose() {
      this.bindOrderForm = {
        user_id: '',
        user_account: '',
        order_ids: []
      };
    },

    bindProvider(row) {
      console.log('开始绑定提供商，用户数据:', row);
      
      this.bindProviderForm.user_id = row.id;
      this.bindProviderForm.user_account = row.account;
      this.bindProviderForm.provider_ids = [];
      this.bindProviderDialogVisible = true;
      
      console.log('绑定提供商表单数据:', this.bindProviderForm);
      
      // 先获取用户已绑定的提供商ID，然后再获取提供商列表
      this.fetchBoundProviders(row.id).then(() => {
        console.log('已绑定提供商获取完成，开始获取提供商列表');
        // 已绑定提供商获取完成后，再获取提供商列表
        this.fetchProviderList();
      }).catch(err => {
        console.error('获取已绑定提供商过程中出错:', err);
        // 即使出错也继续获取提供商列表
        this.fetchProviderList();
      });
    },
    
    // 获取用户已绑定的提供商ID
    fetchBoundProviders(userId) {
      return new Promise((resolve, reject) => {
        console.log('开始获取已绑定提供商，用户ID:', userId);
        console.log('请求地址:', '/api-30216/api/user-providers/bound');
        
        this.$axios.get('/api-30216/api/user-providers/bound', {
          params: {
            user_id: userId
          }
        })
        .then(res => {
          console.log('获取已绑定提供商响应:', res);
          console.log('响应数据:', res.data);
          console.log('响应数据类型:', typeof res.data);
          console.log('响应数据是否为数组:', Array.isArray(res.data));
          
          // 直接使用响应数据，不检查code
          const boundProviderIds = res.data || [];
          console.log('已绑定提供商ID:', boundProviderIds);
          console.log('已绑定提供商数量:', boundProviderIds.length);
          
          // 设置已绑定的提供商ID到表单
          this.bindProviderForm.provider_ids = boundProviderIds;
          
          resolve();
        })
        .catch(err => {
          console.error('获取已绑定提供商失败:', err);
          console.error('错误响应:', err.response);
          console.error('错误消息:', err.message);
          
          let errorMsg = '获取已绑定提供商失败';
          if (err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message;
          } else if (err.message) {
            errorMsg = err.message;
          }
          
          this.$message.error(errorMsg);
          resolve(); // 即使失败也继续执行
        });
      });
    },

    fetchProviderList() {
      this.$axios.get('/api-30216/api/regions', {
        params: {
          page: 1,
          pageSize: 9999
        }
      }).then(res => {
        if (res.code === 200) {
          // 保存所有提供商信息，用于el-transfer组件显示
          this.providerList = (res.data || []).map(provider => ({
            id: provider.id,
            label: provider.provider || '无提供商名称'
          }));
          
          console.log('所有提供商列表:', this.providerList);
          console.log('已绑定提供商ID:', this.bindProviderForm.provider_ids);
        } else {
          this.$message.error(res.message || '获取提供商列表失败');
          this.providerList = [];
        }
      }).catch(err => {
        console.error('获取提供商列表失败:', err);
        this.$message.error('获取提供商列表失败');
        this.providerList = [];
      });
    },

    filterProvider(query, item) {
      return item.label.toLowerCase().includes(query.toLowerCase());
    },

    submitBindProvider() {
      if (this.bindProviderForm.provider_ids.length === 0) {
        this.$message.warning('请至少选择一个提供商');
        return;
      }

      const submitData = {
        user_id: this.bindProviderForm.user_id,
        provider_ids: this.bindProviderForm.provider_ids
      };

      console.log('提交的JSON数据:', JSON.stringify(submitData, null, 2));

      this.bindProviderLoading = true;
      
      // 按照 EditRole 的提交方式，使用 transformRequest 确保数据被正确序列化为 JSON
      this.$axios
        .post('/api-30216/api/user-providers/bind', submitData, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [postData => JSON.stringify(postData)]
        })
        .then(res => {
          console.log('接口响应:', res);
          const responseData = res.data || res;
          if (responseData.code === 200) {
            this.$message.success(responseData.message || '关联提供商成功');
            this.bindProviderDialogVisible = false;
          } else {
            this.$message.error(responseData.message || '关联提供商失败');
          }
        })
        .catch(err => {
          let msg = '关联提供商失败';
          if (err.response && err.response.data && err.response.data.message) {
            msg = err.response.data.message;
          } else if (err.message) {
            msg = err.message;
          }
          this.$message.error(msg);
        })
        .finally(() => {
          this.bindProviderLoading = false;
        });
    },

    handleBindProviderDialogClose() {
      this.bindProviderForm = {
        user_id: '',
        user_account: '',
        provider_ids: []
      };
    }
  }
}
</script>

<style scoped lang="scss"> 
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>